export default class CollisionManager {
    relatedScene: Phaser.Scene;

    constructor(scene: Phaser.Scene) {
        this.relatedScene = scene;
    }

    create(): void {
        this.relatedScene.matter.world.on('collisionstart', function (_: any, bodyA: any, bodyB: any) {

            const movementA = bodyA.gameObject;
            const movementB = bodyB.gameObject;

            if (movementA.payload.counter == movementB.payload.counter) {    
                movementA.owner.decreasePopulation(movementA.payload.counter);
                movementB.owner.decreasePopulation(movementB.payload.counter);
                movementA.destroy();
                movementB.destroy();
            } else if (movementA.payload.counter < movementB.payload.counter) {
                movementB.owner.decreasePopulation(movementA.payload.counter);
                movementA.owner.decreasePopulation(movementA.payload.counter);
                movementB.payload.counter -= movementA.payload.counter;
                movementB.setFrameFromPayload();
                movementA.destroy();
            } else if (movementA.payload.counter > movementB.payload.counter) {
                movementA.owner.decreasePopulation(movementB.payload.counter);
                movementB.owner.decreasePopulation(movementB.payload.counter);
                movementA.payload.counter -= movementB.payload.counter;
                movementA.setFrameFromPayload();
                movementB.destroy();
            }
        });
    }
}